import React from 'react';
import { useDecoratedAssets } from '../../services/Firestore/Resources';
import AssetList from './AssetList';

export const AssetListAll = ({ classes, filter, columnFilter }) => {
  const [assets, assetsLoading] = useDecoratedAssets();
  if (assetsLoading) {
    return 'Loading assets...';
  }
  return (
    <AssetList assets={assets} classes={classes} filter={filter} columnFilter={columnFilter} />
  );
};
